import React from 'react';
import { compose, withState } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import ChangeEmailGroupDialog from '../molecules/ChangeEmailGroupDialog';

const styles = {
  leftIcon: {
    padding: '0px 5px'
  }
};

const enhance = compose(
  withState('openChange', 'updateOpenChange', false),
  withState('openChangeConfirm', 'updateOpenChangeConfirm', false)
);

const button = enhance(
  ({
    groupId,
    openChange,
    disabled,
    updateOpenChange,
    message,
    setMessage,
    openChangeConfirm,
    updateOpenChangeConfirm,
    email
  }) => {
    const updateChange = () => {
      updateOpenChange(true);
    };
    return (
      <div>
        <Button
          disabled={disabled}
          color="primary"
          onClick={() => updateChange(true)}
        >
          メールアドレス変更
        </Button>
        <ChangeEmailGroupDialog
          openChange={openChange}
          updateOpenChange={updateOpenChange}
          target="Change"
          message={message}
          setMessage={setMessage}
          openChangeConfirm={openChangeConfirm}
          updateOpenChangeConfirm={updateOpenChangeConfirm}
          groupId={groupId}
          old={email}
        />
      </div>
    );
  }
);

export default withStyles(styles)(button);
